// extracted by mini-css-extract-plugin
export default {"container":"couponsList_container__lHLuh"};